import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Avatar,
  TextField,
  Button,
  Select,
  MenuItem,
  makeStyles,
  Grow,
  Fade,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CurrencyInput from "react-currency-input";
import axios from "axios";
import {
  BaseURL,
  generateTokenIndividual,
  MasterKeyLogin,
} from "../../../constants/constants";

import { encryptData } from '../../../utils/CryptoHandler';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(8),
  },
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(6),
  },
  nombre: {
    marginBottom: theme.spacing(0),
  },
  montoContainer: {
    display: "flex",
    alignItems: "center",

  },
  bs: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  monto: {
    fontSize: "2.5rem",
    fontWeight: 500,
  },
  conceptoField: {

    width: "80%", // Ajusta el ancho según necesites
    maxWidth: 300,


    '& .MuiInputBase-input::placeholder': { // Apunta al placeholder
      fontSize: 16,
      textAlign: 'left', // Centra el texto del placeholder
    },
    '& .MuiInputBase-input': { // Apunta al input en general para centrar el texto introducido
      textAlign: 'left', // También centra el texto que el usuario escribe
    },
    marginTop: 10,
    // textAlign: "center",
    // '& .MuiInputLabel-root': { // Targets the label element
    //   left: '50%', // Move the label to the horizontal center
    //   //transform: 'translateX(-50%)',
    //   top: '50%',
    //   transform: 'translate(-50%, -50%)',
    // },
  },
  continuarButton: {
    marginTop: 40,
    padding: theme.spacing(0.6, 6),
    borderRadius: 10,
    backgroundColor: "transparent",
    color: "black",
    border: "solid 1px black",
    width: "100%",
  },

  continuarDialogButton: {
    marginTop: 40,
    padding: theme.spacing(0.6, 6),
    borderRadius: 10,
    backgroundColor: "transparent",
    color: "black",
    border: "solid 1px black",

  },
  botonRegresar: {
    marginTop: 60,
    padding: theme.spacing(0.6, 6),
    borderRadius: 12,
    backgroundColor: "transparent",
    color: "#6730E3",
  },
  marginTextFieldCardNumber: {
    width: "100%",
    textAlign: "center",
    fontSize: 40,
    marginTop: 20,
    borderRadius: 0,
    color: "grey",
    border: "solid 0px transparent",

    "&::placeholder": {
      textAlign: "center",
      fontSize: 40,
    },

    "&:focus": {
      outline: "none",
    },
  },

  currencySelector: {
    display: "flex",
    alignItems: "center",
    "& .MuiSelect-select": {
      paddingRight: theme.spacing(3), // Espacio para el icono
      paddingLeft: theme.spacing(0.5),
      fontSize: "1rem",
    },
    "& .MuiSelect-icon": {
      right: theme.spacing(0),
      // Color del icono
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none", // Eliminamos la línea inferior inactiva
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none", // Eliminamos la línea inferior al enfocar
    },
    "&:hover .MuiInput-underline:before": {
      borderBottom: "none", // Eliminamos la línea al pasar el mouse (inactivo)
    },
    "&:hover .MuiInput-underline:after": {
      borderBottom: "none", // Eliminamos la línea al pasar el mouse (enfocado)
    },
  },
  bsText: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  dialogTextField: {

    "& .MuiInput-underline:before": {
      borderBottomColor: "#000000", // Eliminamos la línea inferior inactiva

    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#000000"// Eliminamos la línea inferior al enfocar
    },
    "&:hover .MuiInput-underline:before": {
      borderBottomColor: "#000000" // Eliminamos la línea al pasar el mouse (inactivo)
    },
    "&:hover .MuiInput-underline:after": {
      borderBottomColor: "#000000", // Eliminamos la línea al pasar el mouse (enfocado)
    },
  },
  dialog: {


    "& .MuiDialog-paper": {
      minWidth: "30%",
      borderRadius: 0,
      border: "solid 1px #000000",
    }
  },
  statusDialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 120,
    padding: theme.spacing(2),
  },
  statusIcon: {
    width: 40,
    height: 40,
    marginBottom: theme.spacing(2),
  },
}));

// Componente para mostrar el estado del envío
const StatusDialog = (props) => {
  const { open, handleClose, isSuccess, message } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="status-dialog"
      className={classes.dialog}
    >
      <DialogTitle style={{ display: "flex" }}>
        {/* <img
          src={isSuccess ? check : reject}
          className={classes.statusIcon}
          alt={isSuccess ? "Success" : "Error"}
        /> */}

        {isSuccess ? "Información" : "Error"}
      </DialogTitle>
      <DialogContent>
        <div className={classes.statusDialogContent}>
          <Typography variant="h6" align="center">
            {isSuccess ? "¡Link enviado exitosamente!" : "Error al enviar el correo"}
          </Typography>
          <Typography variant="body1" align="center" style={{ marginTop: 16 }}>
            {message}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Button
          onClick={handleClose}
          className={classes.continuarDialogButton}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function IndividualLinks(props) {
  const classes = useStyles();
  const [site, SetSite] = useState(0)
  const [link, setLink] = useState("");
  const [longLink, setLongLink] = useState("");
  const [montoGeneral, setMontoGeneral] = useState("");
  const [id_usuario, setId_usuario] = useState("");
  const [bcvValue, setBcvValue] = useState();
  const backHomeStep = props.setActiveStep;

  // Estado para controlar el diálogo de estado
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    success: false,
    message: ""
  });

  const showStatusDialog = (success, message) => {
    setStatusDialog({
      open: true,
      success,
      message
    });
  };

  const closeStatusDialog = () => {
    setStatusDialog({
      ...statusDialog,
      open: false
    });
  };

  useEffect(() => {
    setId_usuario(props.id_usuario);
    //getBCV();


  }, [props.id_usuario, props.id_commerce]);

  const getBCV = async () => {
    try {
      const Url = process.env.REACT_APP_URL + process.env.REACT_APP_GET_BCV
      const fechaActual = new Date();
      const fechaFormateada = fechaActual.getFullYear() + '-' + (fechaActual.getMonth() + 1).toString().padStart(2, '0') + '-' + fechaActual.getDate().toString().padStart(2, '0');


      let result = await axios.post(Url, {
        "Moneda": "USD", // Código ISO moneda - String
        "Fechavalor": fechaFormateada,// Fecha consulta de la tasa bcv (yyyy-mm-dd) - String
        "commerceId": props.id_commerce, // Id del comercio - String
      },
        {
          headers: {
            'Authorization': `Bearer ${props.token}`,
            'id_commerce': props.id_commerce
          }
        }
      )

      if (result.data.exito) {
        setBcvValue(result.data.message.valor)
      }
    } catch (error) {

    }
  }

  const SharedLink = (props) => {
    const [open, setOpen] = useState(false);

    const handleShareOnWhatsApp = async (message, id_usuario) => {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

      const sendIndividualLink = async () => {
        try {
          var apiBaseUrl = BaseURL;
          var payload = {
            correo: "",
            link: link,
            id_usuario: id_usuario,
            send_channel: 2
          };

          let result = await axios.post(
            apiBaseUrl + process.env.REACT_APP_SEND_MAIL_INDIVIDUAL,
            payload,
            {
              headers: {
                'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
                'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
              }
            }
          );

          if (result.data.exito) {
            showStatusDialog(true, "Enlace compartido por WhatsApp correctamente");
            return true;
          } else {
            showStatusDialog(false, "Error al enviar por WhatsApp");
            return false;
          }
        } catch (error) {
          showStatusDialog(false, "Error de conexión. Intente nuevamente.");

        }
      };

      let result = await sendIndividualLink();

      if (result) {
        window.open(whatsappUrl, '_blank');
      }
    };

    const handleClickOpen = () => {
      setOpen(true);
    };

    const MailDialog = (props) => {
      const { open, handleClose, link, longLink, id_usuario } = props;
      const [correoElectronico, setCorreoElectronico] = useState("");

      const sendIndividualLink = async () => {

        try {
          var apiBaseUrl = BaseURL;
          var payload = {
            correo: correoElectronico,
            link: link,
            link_largo: longLink,
            id_usuario: id_usuario,
            send_channel: 1
          };

          let result = await axios.post(
            apiBaseUrl + process.env.REACT_APP_SEND_MAIL_INDIVIDUAL,
            payload,
            {
              headers: {
                'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
                'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
              }
            }
          );

          if (result.data.exito) {
            showStatusDialog(true, `Enlace enviado a: ${correoElectronico}`);
            handleClose();
            return true;
          } else {
            showStatusDialog(false, result.data.mensaje || "Error al enviar el enlace");
            handleClose();
            return false;
          }
        } catch (error) {
          showStatusDialog(false, "Error de conexión. Intente nuevamente.");
          handleClose();

        }
      };
      return (
        <>
          <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Correo Electrónico</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Ingresa el correo Electrónico al que deseas enviar el enlace
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                onChange={(e) => setCorreoElectronico(e.target.value)}
                label="Correo Electrónico"
                type="email"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={sendIndividualLink} color="primary">
                Enviar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )
    }

  };

  const SetAmountConcepts = (props) => {
    const [amount, setAmount] = useState("");
    const [concepto, setConcepto] = useState("");
    const [open, setOpen] = useState(false);
    const [currency, setCurrency] = React.useState("Bs");
    const [canal, setCanal] = useState("email"); // Email por defecto
    const [loading, setLoading] = useState(false);

    // Validación para deshabilitar el botón
    const motivoInvalido = concepto.trim().length < 4;
    const montoNumber = parseFloat(
      String(amount || "")
        .replace(/\./g, "")
        .replace(",", ".")
    );
    const montoInvalido = isNaN(montoNumber) || montoNumber < 1.00;
    const montoEsCero = !amount || montoNumber === 0;
    const compartirDisabled = motivoInvalido || montoInvalido;

    const handleCompartir = (e) => {
      if (canal === "email") {
        handleClick(e, 1);
      } else {
        handleClick(e, 2);
      }
    };

    const handleClick = async (e, tipo) => {
      e.preventDefault();
      setLoading(true);
      try {
        if (tipo === 1) {
          setOpen(true);
        } else {
          console.log("Compartir por WhatsApp ", props);
          await handleShareOnWhatsApp(props.link, id_usuario, props.nombre_usuario, amount, concepto, currency, props.expired);
        }
      } catch (error) {
        showStatusDialog(false, "Ocurrió un error inesperado");
      } finally {
        setLoading(false);
      }
    };

    const MailDialog = (props) => {
      const { open, handleClose, id_usuario, nombre_usuario, amount, concepto, tipo_moneda, expired, id_commerce, token } = props;
      const [correoElectronico, setCorreoElectronico] = useState("");
      const [loadingDialog, setLoadingDialog] = useState(false);

      const sendIndividualLink = async (link,longlink) => {
        try {
          setLoadingDialog(true);
          var apiBaseUrl = BaseURL;
          var payload = {
            correo: correoElectronico,
            link: link,
            link_largo: longlink,
            id_usuario: id_usuario,
            send_channel: 1,
          };

          let result = await axios.post(
            apiBaseUrl + process.env.REACT_APP_SEND_MAIL_INDIVIDUAL,
            payload,
            {
              headers: {
                'Authorization': `Bearer ${encryptData(token, process.env.REACT_APP_LOGIN_KEY)}`,
                'id_commerce': encryptData(id_commerce, process.env.REACT_APP_LOGIN_KEY)
              }
            }
          );

          if (result.data.exito) {
            showStatusDialog(true, `Enlace enviado a: ${correoElectronico}`);
            handleClose();
          } else {
            showStatusDialog(false, result.data.mensaje || "Error al enviar el enlace");
          }
        } catch (error) {
          showStatusDialog(false, "Error de conexión. Intente nuevamente.");

        } finally {
          setLoadingDialog(false);
        }
      };

      const generateLinkIndividualPlink = async () => {
        try {
          let convertedAmount;
          if (tipo_moneda === "USD") {
            convertedAmount = parseFloat(amount) * props.bcvValue;
            convertedAmount = parseFloat(convertedAmount).toFixed(2);
          }

          setLoadingDialog(true);
          var apiBaseUrl = BaseURL;
          var payload = {
            user: nombre_usuario,
            correo: correoElectronico,
            monto: tipo_moneda === "USD" ? convertedAmount : amount,
            concepto: concepto,
            tipo_moneda: tipo_moneda,
            expired: expired
          };

          let result = await axios.post(
            apiBaseUrl + generateTokenIndividual,
            payload,
            {
              headers: {
                'Authorization': `Bearer ${encryptData(token, process.env.REACT_APP_LOGIN_KEY)}`,
                'id_commerce': encryptData(id_commerce, process.env.REACT_APP_LOGIN_KEY)
              }
            }
          );

          if (result.data.exito) {
            const generatedLink = result.data.link_enmascarado;
            const longLink = result.data.link;
            await sendIndividualLink(generatedLink, longLink);
          } else {
            showStatusDialog(false, "Error al generar el enlace");
          }
        } catch (error) {

          showStatusDialog(false, "Error en el servidor");
        } finally {
          setLoadingDialog(false);
        }
      };

      return (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          className={classes.dialog}
        >
          <DialogTitle id="form-dialog-title">
            Correo electrónico
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="email-input"
              value={correoElectronico}
              onChange={(e) => setCorreoElectronico(e.target.value)}
              placeholder="Correo Electrónico"
              type="email"
              fullWidth
              className={classes.dialogTextField}
              disabled={loadingDialog}
            />
          </DialogContent>
          <DialogActions style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
            <Button
              onClick={handleClose}
              className={classes.continuarDialogButton}
              disabled={loadingDialog}
            >
              Cancelar
            </Button>
            <Button
              onClick={generateLinkIndividualPlink}
              className={classes.continuarDialogButton}
              disabled={loadingDialog || !correoElectronico}
            >
              {loadingDialog ? "Enviando..." : "Enviar"}
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    // const handleShareOnWhatsApp = async (message, id_usuario, nombre_usuario, amount, concepto, tipo_moneda, expired) => {
    //   try {

    //     const encoded = encodeURIComponent(message);
    //     console.log("Mensaje original:", message);
    //     console.log("Mensaje codificado:", encoded);
    //     // Detectar si es móvil
    //     const isMobile = /iPhone|Android/i.test(navigator.userAgent);
    //     // En móviles usamos 'whatsapp://', en PC 'https://web.whatsapp.com/'

    //     // const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    //     const link = await generateLinkIndividualPlink(nombre_usuario, amount, concepto, tipo_moneda, expired);
    //     const whatsappUrl = isMobile
    //       ? `whatsapp://send?text=${encodeURIComponent(link)}`
    //       : `https://web.whatsapp.com/send?text=${encodeURIComponent(link)}`;
    //     if (link) {
    //       const result = await sendIndividualLink(link, id_usuario);
    //       if (result) {
    //         window.open(whatsappUrl, '_blank');
    //         showStatusDialog(true, "Enlace compartido por WhatsApp correctamente");
    //       }
    //     }
    //   } catch (error) {
    //     showStatusDialog(false, "Error al compartir por WhatsApp");
    //   }
    // };



    const handleShareOnWhatsApp = async (message, id_usuario, nombre_usuario, amount, concepto, tipo_moneda, expired) => {
      try {
        // Generar el enlace de pago
        const link = await generateLinkIndividualPlink(nombre_usuario, amount, concepto, tipo_moneda, expired);

        // Construir el mensaje con el formato deseado
        const mensajeCompleto = `SOLICITUD DE PAGO 🎫

Haz recibido una solicitud de cobro a través de *R4 Plink*.
*Solicitante:* ${nombre_usuario}
*Monto:* ${amount}
*Concepto:* ${concepto}

¿Deseas generar el pago ahora? Pulsa el enlace para pagar:
${link.link_enmascarado}`;

        if (link.link) {
          // Registrar el enlace (opcional, según tu lógica)
          const result = await sendIndividualLink(link.link, id_usuario);
          if (result) {
            // const isMobile = /iPhone|Android/i.test(navigator.userAgent);
            // const whatsappUrl = isMobile
            //   ? `whatsapp://send?text=${encodeURIComponent(mensajeCompleto)}`
            //   : `https://web.whatsapp.com/send?text=${encodeURIComponent(mensajeCompleto)}`;

            const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(mensajeCompleto)}`;

            const win = window.open(whatsappUrl, '_blank');

            if (win) {
              win.focus();
              showStatusDialog(true, "Enlace compartido correctamente");
            } else {
              // Si Safari lo bloqueó de todos modos, usamos fallback de locación
              // Esto no abre pestaña nueva, pero evita el bloqueo.
              window.location.href = whatsappUrl;
            }
          }
        }
      } catch (error) {
        showStatusDialog(false, "Error al compartir por WhatsApp");
      }
    };

    const generateLinkIndividualPlink = async (nombre_usuario, amount, concepto, tipo_moneda, expired) => {
      try {
        var apiBaseUrl = BaseURL;
        var payload = {
          user: nombre_usuario,
          monto: amount,
          concepto: concepto,
          tipo_moneda: tipo_moneda,
          expired: expired
        };

        let result = await axios.post(
          apiBaseUrl + generateTokenIndividual,
          payload,
          {
            headers: {
              'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
              'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
            }
          }
        );

        if (result.data.exito) {
          return result.data;
        } else {
          showStatusDialog(false, "Error al generar el enlace");
          return null;
        }
      } catch (error) {

        showStatusDialog(false, "Error en el servidor");
        return null;
      }
    };

    const sendIndividualLink = async (link, id_usuario) => {
      try {
        var apiBaseUrl = BaseURL;
        var payload = {
          correo: "",
          link: link,
          id_usuario: id_usuario,
          send_channel: 2
        };

        let result = await axios.post(
          apiBaseUrl + process.env.REACT_APP_SEND_MAIL_INDIVIDUAL,
          payload,
          {
            headers: {
              'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
              'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
            }
          }
        );

        if (result.data.exito) {
          return true;
        } else {
          showStatusDialog(false, "Error al enviar el enlace");
          return false;
        }
      } catch (error) {

        showStatusDialog(false, "Error de conexión");
        return false;
      }
    };

    const handleChangeCurrency = (event) => {
      setAmount("")
      setCurrency(event.target.value);
    };

    const noPaste = (e) => {
      e.preventDefault();
      return false;
    };

    function validate(e) {
      var key = window.event ? e.which : e.keyCode;
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
      if (e.target.value.length === 13) {
        e.preventDefault();
      }
    }

    function handleChange(event, maskedvalue, floatvalue) {
      setAmount(maskedvalue);
    }

    const handleChangeConcept = (e) => {
      setConcepto(e.target.value);
    };

    return (
      <Fade in={true} style={{ transformOrigin: "0 0 0" }} timeout={500}>
        <Container
          style={{
            fontFamily: "Helvetica",
            fontSize: 16,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: 0,
            marginTop: 20,
            width: "100%"
          }}
        >
          <MailDialog
            open={open}
            handleClose={() => setOpen(false)}
            id_usuario={id_usuario}
            nombre_usuario={props.nombre_usuario}
            amount={amount}
            concepto={concepto}
            tipo_moneda={currency}
            bcvValue={props.bcvValue}
            expired={props.expired}
            id_commerce={props.id_commerce}
            token={props.token}
          />

          <Typography variant="h6" style={{ marginTop: 20, marginBottom: 20 }}>Total a cobrar:</Typography>

          <div className={classes.montoContainer} style={{ position: "relative", width: "100%" }}>
            <form autoComplete="off" component="form">
              <CurrencyInput
                variant="outlined"
                placeholder="0,00"
                margin="normal"
                value={amount}
                required
                size="small"
                id="amount"
                name="amount"
                onChange={handleChange}
                autoFocus
                onPaste={noPaste}
                inputType="tel"
                onKeyPress={validate}
                autoComplete="off"
                decimalSeparator=","
                thousandSeparator="."
                style={{
                  fontSize: 16,
                  fontFamily: 'Helvetica',
                  minWidth: 400,
                  height: 40,
                  border: '1px solid #bdbdbd',
                  borderRadius: 8,
                  padding: '0 14px',
                  boxSizing: 'border-box',
                  outline: 'none',
                  background: '#fff',
                  color: '#222',
                  marginBottom: 0,
                  marginTop: 0,
                  textAlign: 'left'
                }}
              />
            </form>
            <Select
              id="currency-select"
              value={currency}
              onChange={handleChangeCurrency}
              displayEmpty
              IconComponent={ArrowDropDownIcon}
              variant="outlined"
              style={{
                marginLeft: 12,
                height: 40,
                fontSize: 16,
                fontFamily: 'Helvetica',
                minWidth: 80,
                background: '#fff',
                borderRadius: 8,
                paddingLeft: 8,
                paddingRight: 8,
                boxSizing: 'border-box',
                alignSelf: 'stretch'
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
            >
              <MenuItem value="Bs">Bs</MenuItem>
              {/* <MenuItem value="USD">USD</MenuItem> */}
            </Select>
            {(!amount || montoNumber === 0) && (
              <Typography variant="body2" style={{ color: 'red', marginLeft: 16, marginTop: 4 }}>
                El monto no puede ser 0,00
              </Typography>
            )}
          </div>
          <TextField
            variant="outlined"
            style={{ fontSize: 16, fontFamily: 'Helvetica', minWidth: 400 }}
            InputProps={{
              style: { fontSize: 16, fontFamily: 'Helvetica', height: 40 }
            }}
            placeholder="Motivo"
            onChange={handleChangeConcept}
            className={classes.conceptoField}
          />
          {concepto.trim().length > 0 && concepto.trim().length < 4 && (
            <Typography variant="body2" style={{ color: 'red', marginLeft: 8, marginTop: 4 }}>
              Ingrese un motivo de al menos 4 letras
            </Typography>
          )}
          <Typography variant="h6" style={{ marginTop: 20 }}>Compartir a través</Typography>
          <div style={{ display: "flex", flexDirection: "column", gap: 20, margin: "16px 0" }}>
            <label style={{ display: "flex", alignItems: "center", fontFamily: "Helvetica", fontSize: 16, color: "#000", marginBottom: 8 }}>
              <input
                type="checkbox"
                checked={canal === "email"}
                onChange={() => setCanal("email")}
                style={{ width: 28, height: 28, marginRight: 16, fontSize: 16, fontFamily: 'Helvetica' }}
              />
              Email
            </label>
            <label style={{ display: "flex", alignItems: "center", fontFamily: "Helvetica", fontSize: 16, color: "#000" }}>
              <input
                type="checkbox"
                checked={canal === "whatsapp"}
                onChange={() => setCanal("whatsapp")}
                style={{ width: 28, height: 28, marginRight: 16 }}
              />
              WhatsApp
            </label>
          </div>

          <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%" mt={4}>
            <Button
              variant="outlined"
              style={{
                background: '#fff',
                color: '#ff5100',
                height: 40,
                fontSize: 16,
                borderRadius: 4,
                minWidth: 180,
                boxShadow: 'none',
                border: '2.5px solid #ff5100',
                textTransform: 'none',
                padding: '8px 0',
                marginRight: 24
              }}
              onClick={() => backHomeStep(0)}
            >
              Atrás
            </Button>
            <Button
              variant="contained"
              disabled={compartirDisabled || loading}
              style={{
                background: compartirDisabled || loading ? "#fff" : "#ff5100",
                color: compartirDisabled || loading ? "#ff5100" : "#fff",
                height: 40,
                fontSize: 16,
                borderRadius: 4,
                minWidth: 180,
                boxShadow: 'none',
                border: '2.5px solid #ff5100',
                textTransform: 'none',
                padding: '8px 0',
              }}
              onClick={handleCompartir}
            >
              {loading ? "Enviando..." : "Compartir"}
            </Button>
          </Box>
        </Container>
      </Fade>
    );
  };

  return (
    <>
      <StatusDialog
        open={statusDialog.open}
        handleClose={closeStatusDialog}
        isSuccess={statusDialog.success}
        message={statusDialog.message}
      />

      {site === 0 ? (
        <SetAmountConcepts
          nombre_usuario={props.nombre_usuario}
          img={props.img}
          SetSite={SetSite}
          setLink={setLink}
          link={link}
          setMontoGeneral={setMontoGeneral}
          bcvValue={bcvValue}
          expired={props.expired}
          token={props.token}
          id_commerce={props.id_commerce}
        />
      ) : (
        <SharedLink
          link={link}
          longLink={longLink}
          monto={montoGeneral}
          SetSite={SetSite}
          token={props.token}
          id_commerce={props.id_commerce}
        />
      )}
    </>
  );
}

export default IndividualLinks;
//MERGE FILE VALIDADO